// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27aLw","index":"styles_index__KcZeR"};